<template>
  <div class="ck_pupop">
    <div class="pupop_form" v-loading="loading">
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="155px"
        label-position="right"
      >
        <div class="top">
          <el-form-item label="仓库类型:" prop="cklx">
            <el-select
              v-model="form.cklx"
              :disabled="leixing == 'query' || leixing == 'edit'"
              placeholder="请选择"
              style="width: 265px"
            >
              <el-option label="自有仓库" value="1" />
              <el-option label="租用仓库" value="2" />
              <el-option label="虚拟仓库" value="3" />
            </el-select>
          </el-form-item>
          <el-form-item
            label="仓库名称:"
            prop="ckmc"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 200);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.ckmc"
              :disabled="leixing == 'query' || leixing == 'edit'"
              style="width: 265px"
            />
          </el-form-item>
          <el-form-item
            v-if="form.cklx == 2"
            label="货主单位保管员:"
            prop="ckbgy"
          >
            <el-select
              v-model="form.ckbgy"
              :disabled="leixing == 'query'"
              style="width: 265px"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, i) in bgyList"
                :key="i"
                :label="item.label"
                :value="item"
                @click.native="bgyClickChange(item)"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-else label="保管员:" prop="ckbgy">
            <el-select
              v-model="form.ckbgy"
              :disabled="leixing == 'query'"
              style="width: 265px"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, i) in bgyList"
                :key="i"
                :label="item.label"
                :value="item"
                @click.native="bgyClickChange(item)"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.cklx == 2" label="货主单位保管员电话:">
            <el-input v-model="form.ckbgyDh" disabled style="width: 265px" />
          </el-form-item>
          <el-form-item v-else label="保管员电话:">
            <el-input v-model="form.ckbgyDh" disabled style="width: 265px" />
          </el-form-item>
          <el-form-item
            v-if="form.cklx == 2"
            label="租赁单位:"
            prop="zydwMc"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 200);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.zydwMc"
              style="width: 70%"
              :disabled="leixing == 'query'"
            />
            <el-button
              type="primary"
              style="background: #4170ff"
              @click="selectDw"
            >选择</el-button>
          </el-form-item>
          <el-form-item
            v-if="form.cklx == 2"
            label="统一社会信用代码:"
            prop="zydwTyshxydm"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 100);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.zydwTyshxydm"
              :disabled="leixing == 'query'"
              style="width: 265px"
            />
          </el-form-item>
          <el-form-item
            v-if="form.cklx == 2"
            label="租赁单位保管员:"
            prop="zydwBgyxm"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 200);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.zydwBgyxm"
              :disabled="leixing == 'query'"
              style="width: 265px"
            />
          </el-form-item>
          <el-form-item
            v-if="form.cklx == 2"
            label="租赁单位保管员身份证号:"
            prop="zydwBgysfz"
          >
            <el-input
              v-model="form.zydwBgysfz"
              :disabled="leixing == 'query'"
              style="width: 265px"
            />
          </el-form-item>
          <el-form-item
            v-if="form.cklx == 2"
            label="租赁单位保管员电话:"
            prop="zydwBgydh"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 50);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.zydwBgydh"
              :disabled="leixing == 'query'"
              style="width: 265px"
            />
          </el-form-item>
          <el-form-item v-if="form.cklx == 2" label="最大仓储量:" prop="ccl">
            <div style="width: 265px">
              <el-input
                v-model="form.ccl"
                :disabled="leixing == 'query'"
                style="width: 60%"
              />
              <el-select
                v-model="form.cclDw"
                :disabled="leixing == 'query'"
                style="width: calc(40% - 10px); margin-left: 10px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in yzd_nsjsl_dw"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </el-form-item>
        </div>

        <el-form-item v-if="form.cklx != 2" label="最大仓储量:" prop="ccl">
          <el-input
            v-model="form.ccl"
            :disabled="leixing == 'query'"
            style="width: 80%"
          />
          <el-select
            v-model="form.cclDw"
            :disabled="leixing == 'query'"
            style="width: calc(20% - 10px); margin-left: 10px"
            placeholder="单位"
          >
            <el-option
              v-for="item in yzd_nsjsl_dw"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="仓库所在地行政区划:" prop="gajg">
          <el-input v-if="leixing == 'query' || leixing == 'edit'" disabled
            v-model="form.provinceLabel+' / '+form.cityLabel+' / '+form.countyLabel"
            placeholder="请输入行政区划"
          />
          <el-cascader v-else
            v-model="gajg"
            style="width: 100%"
            clearable
            placeholder=""
            :props="props"
            @change="jgChange"
          />
        </el-form-item>
        <el-form-item
          label="仓库地址:"
          prop="ckdz"
          :rules="{
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 600);
            },
            trigger: ['blur', 'change'],
          }"
        >
          <el-input
            v-model="form.ckdz"
            :disabled="leixing == 'query' || leixing == 'edit'"
          />
        </el-form-item>
        <el-row :gutter="30">
          <el-col :span="4">
            <el-form-item
              label="是否有监控:"
              style="display: inline-block; margin-right: 50px"
              prop="sfysxt"
            >
              <el-switch
                v-model="form.sfysxt"
                :disabled="leixing == 'query'"
                active-value="Y"
                inactive-value="N"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="isShowTestMenu" :span="4" :offset="1">
            <el-form-item
              label="是否为保险柜:"
              prop="sfysxt"
            >
              <el-switch
                v-model="sfbxg"
                :disabled="leixing == 'query'"
                active-value="Y"
                inactive-value="N"
              />
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <div
        v-if="
          leixing == 'query' &&
            form.sphjDtos !== undefined &&
            form.sphjDtos !== null &&
            form.sphjDtos.length > 0
        "
        style="margin-bottom: 40px"
      >
        <div class="_title _title2">
          <p class="_title_info">公安审批结果</p>
        </div>

        <div
          v-for="(item, index) in form.sphjDtos"
          :key="index"
          style="margin-bottom: 30px"
        >
          <!--  -->
          <el-timeline>
            <el-timeline-item v-if="item[0]" icon="el-icon-time" size="large">
              <div style="margin-top: 2px">
                <span style="font-weight: bold"> 申请时间： </span>
                <span>{{ item[0].clsj }}</span>
              </div>
            </el-timeline-item>
            <el-timeline-item
              v-for="(arr, key) in item"
              :key="key"
              :icon="key == item.length - 1 ? 'el-icon-success' : ''"
              :type="arr.type"
              :size="key == item.length - 1 ? 'large' : arr.size"
              :color="arr.color"
            >
              <div style="display: flex">
                <div style="margin-right: 20px">
                  <span style="font-weight: bold">审批单位：</span>{{ arr.dqbmLabel }}
                </div>
                <div
                  v-if="arr.sftyLabel !== '待审批'"
                  style="margin-right: 20px"
                >
                  <span style="font-weight: bold">{{ arr.jsLabel }}人：</span>{{ arr.sjsprLabel }}
                </div>
                <div style="margin-right: 20px">
                  <span style="font-weight: bold">审批结果：</span><span
                    :style="
                      arr.sftyLabel == '同意'
                        ? 'color: #00ceb7'
                        : arr.sftyLabel == '不同意'
                          ? 'color: red'
                          : 'color: Orange'
                    "
                  >{{ arr.sftyLabel }}</span>
                </div>
                <div
                  v-if="arr.sftyLabel !== '待审批'"
                  style="margin-right: 20px"
                >
                  <span style="font-weight: bold">审批时间：</span>{{ arr.spsj }}
                </div>
              </div>
              <div v-if="arr.sftyLabel !== '待审批'" style="margin-top: 2px">
                <span style="font-weight: bold">审批意见：</span><span>{{ arr.spyj }}</span>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <div style="text-align: center">
        <el-button
          v-preventReClick
          type="primary"
          style="background: #4170ff"
          @click="queding"
        >确定</el-button>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        title="选择租赁单位"
        append-to-body
        :visible="showDialog"
        center
        @close="showDialog = false"
      >
        <div>
          <el-table
            ref="dialogdw"
            :data="tableData"
            style="width: 100%"
            border
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" align="center" :max="1" :min="1" />
            <el-table-column label="单位名称" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.dwmc }}</span>
              </template>
            </el-table-column>
            <el-table-column label="单位地址" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.dwdz }}</span>
              </template>
            </el-table-column>
            <el-table-column label="法人/经营者名称" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.frmc }}</span>
              </template>
            </el-table-column>
            <el-table-column label="单位座机" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.dwzj }}</span>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" align="center">
              <template slot-scope="scope">
                <span size="medium">{{ scope.row.cjsj }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev,pager,next,jumper,total,sizes"
            :total="total"
            :page-sizes="[10, 20]"
            :page-size="pagesize"
            :current-page="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button
            v-preventReClick
            type="primary"
            @click="confirm1"
          >确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { lengthValidate } from '@/assets/js/validate'
import {
  getXzqTree,
  getXzqTreeS,
  detail,
  addOrUpdSave,
  getWldwList,
  getCkgly,
  getQueryXx
} from '@/assets/js/ckgl.js'
export default {
  components: {},
  props: {
    leixing: String,
    content: String
  },
  data() {
    const gajgjiaoyan = (rule, value, callback) => {
      if (this.gajg.length == 0) {
        return callback(new Error('请选择仓储所在地行政区划'))
      } else {
        callback()
      }
    }
    const cclValidator = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入最大仓储量'))
      }
      if (/^[1-9]\d{0,12}(\.\d{1,2})?$|^0(\.\d{1,2})?$/.test(value) == false) {
        callback(new Error('整数位最大长度13位,保留2位小数'))
      }
      if (!this.form.cclDw) {
        callback(new Error('请选择最大仓储量单位'))
      }
      callback()
    }

    return {
      props: {
        lazy: true, // 开启懒加载
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            if (level == 0) {
              getXzqTree().then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            } else {
              getXzqTreeS(node.value).then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            }
          }, 100)
        }
      },
      /*  */
      sfbxg: false,
      isShowTestMenu: false,
      tableData: [],
      showDialog: false,
      pagesize: 10,
      currentPage: 1,
      total: 0,
      multipleSelection: '',
      /*  */
      loading: false,
      gajg: [],
      options: [],
      bgyList: [],
      yzd_nsjsl_dw: [{ label: '吨', value: '1' }],
      jkType: null,
      form: {
        id: '',
        dwid: '',
        cklx: '',
        ckmc: '',
        ckdz: '',
        ckbgy: '',
        ckbgySfz: '',
        ckbgyDh: '',
        st: '',
        sj: '',
        qxj: '',
        pcs: '',
        ccl: '',
        cclDw: '',
        sfysxt: '',
        zydwMc: '',
        zydwTyshxydm: '',
        zydwBgyxm: '',
        zydwBgysfz: '',
        zydwBgydh: ''
      },
      rules: {
        cklx: [{ required: true, message: '请选择仓库类型', trigger: 'blur' }],
        // ckmc: [{ required: true, message: "请输入仓库名称", trigger: "blur" }],
        // zydwMc: [
        //   { required: true, message: "请输入租赁单位", trigger: "blur" },
        // ],
        // zydwTyshxydm: [
        //   {
        //     required: true,
        //     message: "请输入统一社会信用代码",
        //     trigger: "blur",
        //   },
        // ],
        // zydwBgyxm: [
        //   { required: true, message: "请输入租赁单位保管员", trigger: "blur" },
        // ],
        zydwBgysfz: [
          {
            required: true,
            message: '请输入身份证号',
            trigger: 'blur'
          },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '证件号码格式有误！',
            trigger: 'blur'
          },

          {
            min: 1,
            max: 100,
            message: '内容不能超过100个字符',
            trigger: 'blur'
          }
        ],
        // zydwBgydh: [
        //   { required: true, message: "请输入手机号", trigger: "blur" },
        // ],
        ccl: [
          {
            required: true,
            validator: cclValidator,
            trigger: ['blur', 'change']
          }
        ],
        ckbgy: [
          {
            required: true,
            message: '请选择保管员',
            trigger: 'blur'
          }
        ],
        ckbgyDh: [
          { required: true, message: '请输入保管员电话', trigger: 'blur' },
          {
            // pattern:
            //   /^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/,
            message: '手机号格式不对',
            // trigger: "blur",
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const mobile = /^1[3456789]\d{9}$/
              if (!value) {
                return callback(new Error('手机号不能为空！'))
              }
              if (!mobile.test(value)) {
                return callback(new Error('手机号格式错误！'))
              }
              callback()
            }
          }
        ],
        gajg: [
          {
            required: true,
            validator: gajgjiaoyan,
            trigger: 'blur'
          }
        ]
        // ckdz: [{ required: true, message: "请输入仓库地址", trigger: "blur" }],
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    // 获取管理员
    getCkgly().then((e) => {
      this.bgyList = e.data.data
    })
  },
  mounted() {
    this.isShowTestMenu = process.env.VUE_APP_SHOW_TEST_MENU === 'true'
    if (this.leixing == 'edit') {
      detail(this.content).then((e) => {
        this.$nextTick(() => {
          this.loading = false
          this.form = e.data.data
          this.gajg.push(e.data.data.province)
          this.gajg.push(e.data.data.city)
          this.gajg.push(e.data.data.county)
          this.gajg = this.gajg.filter((s) => {
            return s != null && s != ''
          })
        })
      })
    } else if (this.leixing == 'query') {
      getQueryXx(this.content).then((e) => {
        this.$nextTick(() => {
          this.loading = false
          this.form = e.data.data
          this.gajg.push(e.data.data.province)
          this.gajg.push(e.data.data.city)
          this.gajg.push(e.data.data.county)
          this.gajg = this.gajg.filter((s) => {
            return s != null && s != ''
          })
        })
      })
    }
  },
  beforeDestroy() {},
  methods: {
    lengthValidate,
    // 往来单位确认时关闭弹窗并将选中单位id传到父组件
    confirm1() {
      if (this.multipleSelection != '') {
        var data = this.multipleSelection
        this.form.zydwMc = data.dwmc
        this.form.zydwTyshxydm = data.shtyxydm
      }
      this.multipleSelection = [] // 关闭时清空选择数据
      this.$refs.dialogdw.clearSelection() // 关闭时清空选择框
      this.showDialog = false
    },
    // 多选框只能选择一行
    handleSelectionChange(val) {
      this.multipleSelection = val[0]
      if (val.length > 1) {
        this.$refs.dialogdw.clearSelection()
        this.$refs.dialogdw.toggleRowSelection(val.pop())
      }
    },
    handleSizeChange(val) {
      this.pagesize = val
      this.getHxpxxMet()
    },
    // 控制页面的切换
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.getHxpxxMet()
    },
    selectDw() {
      if (this.leixing != 'query') {
        this.showDialog = true
        getWldwList({
          page: this.currentPage,
          size: this.pagesize,
          param: {}
        }).then((e) => {
          this.tableData = e.data.data.rows
          this.total = e.data.data.total
        })
      }
    },
    queding() {
      if (this.leixing == 'query') {
        this.$parent.$parent.dialogVisible = false
      } else if (this.leixing == 'add') {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loading = true
            addOrUpdSave(this.form).then((e) => {
              this.loading = false
              this.$message({
                showClose: true,
                message: '添加成功',
                type: 'success'
              })
              this.$parent.$parent.addOrUpdSave()
            }).catch((error) => {
              this.loading = false
            })
          }
        })
      } else if (this.leixing == 'edit') {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loading = true
            addOrUpdSave(this.form).then((e) => {
              this.loading = false
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success'
              })
              this.$parent.$parent.addOrUpdSave()
            }).catch((error) => {
              this.loading = false
            })
          }
        })
      }
    },

    bgyClickChange(data) {
      this.form.ckbgyDh = data.sjhm
      this.form.ckbgy = data.label
      this.form.ckbgyId = data.value
    },
    jgChange(value) {
      this.form.province = value[0] || ''
      this.form.city = value[1] || ''
      this.form.county = value[2] || ''
    }
  }
}
</script>
<style lang="less" scoped>
.ck_pupop {
  .pupop_form {
    .el-form div:nth-child(3),
    .el-form div:nth-child(2) {
      .el-form-item__content {
        .el-select {
          width: 100%;
          .el-input {
            .el-input__inner {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .top {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .el-form-item {
      .el-form-item__content {
        width: 265px;
      }
    }
  }
}
._title {
  margin-top: 10px;
  width: 100%;
  ._title_info {
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #434343;
    line-height: 32px;
    height: 32px;
    font-family: Helvetica;
  }
}
.spResult {
  width: 90%;
  max-width: 950px;
  display: flex;
  // justify-content: space-between;
  margin: auto;
  .spjg {
    display: flex;
    align-items: center;
  }
}
/deep/.el-timeline-item__icon {
  font-size: 16px !important;
  color: #fff;
  background-color: #ef9a12;
  border-radius: 50%;
}

/deep/.el-icon-success {
  color: #6acd18;
  background-color: #fff;
}
</style>
